const SRC = "/logo-themensclinic.png";

// For dark backgrounds (sidebar, login hero): invert the black wordmark to white.
export const Logo = ({ className = "", height = "h-8" }) => {
  return (
    <img
      src={SRC}
      alt="The Men's Clinic"
      className={`${height} w-auto invert ${className}`}
    />
  );
};

// For light backgrounds (auth cards, mobile header): use the black wordmark as-is.
export const LogoDark = ({ className = "", height = "h-9" }) => {
  return (
    <img
      src={SRC}
      alt="The Men's Clinic"
      className={`${height} w-auto ${className}`}
    />
  );
};
